import React from 'react';
import { Button } from '@mui/material';
import OTPInputField from '../../../common/components/Inputs/OTPInputField';

const SimpleVerifyOTPForm = ({
    verificationCode,
    onChangeAuthForm,
    disabled = false,
}) => {
    return (
        <div
            data-keeper-disable="true"
            data-keeper-ignore="true"
            data-password-manager="disabled"
        >
            <OTPInputField
                verificationCode={verificationCode || ''}
                onChangeAuthForm={onChangeAuthForm}
                name="verificationCode"
                disableKeeper={true}
                disabled={disabled}
            />
        </div>
    );
};

export default SimpleVerifyOTPForm;
